import { render, staticRenderFns } from "./tiwen.vue?vue&type=template&id=5b989d5e&scoped=true&"
import script from "./tiwen.vue?vue&type=script&lang=js&"
export * from "./tiwen.vue?vue&type=script&lang=js&"
import style0 from "./tiwen.vue?vue&type=style&index=0&id=5b989d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b989d5e",
  null
  
)

export default component.exports